<template>
  <div class="index-page">
    <div class="page-header">
      <div class="header-1280">
        <img class="header-logo" src="../../public/static/indexUse/logo3.svg" />
        <div v-if="isMobile" class="flex-row">
          <a-dropdown :trigger="['click']" placement="bottomRight" v-if="headerListServer && headerListServer.length">
            <a-button type="link">
              {{ $t('相关链接') }}
              <dol-icon type="DownOutlined" />
            </a-button>
            <template #overlay>
              <a-menu>
                <a-menu-item v-for="item in headerListServer" :key="item._id">
                  <a-button type="link" @click="headerLinkJump(item)">
                    <div class="flex-row">
                      <img v-if="item.icon" style="height: 16px;margin-right: 4px" :src="$Dolphin.path.publicPath + item.icon?.filePath" />
                      {{ $dt(item, 'name') }}
                    </div>
                  </a-button>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
          <div class="change-lang" @click="changeLang">
            <dol-icon type="GlobalOutlined" />
            {{ nowLang }}
          </div>
          <a-popover trigger="click" placement="bottomRight" v-model:open="menuPop">
            <div class="menu-mobile">
              <dol-icon type="MenuOutlined" />
            </div>
            <template #content>
              <a-menu v-model:openKeys="openKeys" v-model:selectedKeys="selectedKeys"
                      :items="menuMobile" mode="inline" style="width: 200px" @click="menuClick" />
            </template>
          </a-popover>
        </div>
        <div class="header-right" v-else>
          <div class="header-right-top">
            <div class="out-link-box">
              <a-button type="link" v-for="item in headerList.outerList" :key="item._id" @click="headerLinkJump(item)">
                <div class="flex-row">
                  <img v-if="item.icon" style="height: 16px;margin-right: 4px" :src="$Dolphin.path.publicPath + item.icon?.filePath" />
                  {{ $dt(item, 'name') }}
                </div>
              </a-button>
              <a-dropdown placement="bottomRight" v-if="headerList.innerList && headerList.innerList.length">
                <a-button type="link">
                  {{ $t('更多-首页专用') }}
                  <dol-icon type="DownOutlined" />
                </a-button>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="item in headerList.innerList" :key="item._id">
                      <a-button type="link" @click="headerLinkJump(item)">
                        <div class="flex-row">
                          <img v-if="item.icon" style="height: 16px;margin-right: 4px" :src="$Dolphin.path.publicPath + item.icon?.filePath" />
                          {{ $dt(item, 'name') }}
                        </div>
                      </a-button>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
            <div class="change-lang" @click="changeLang">
              <dol-icon type="GlobalOutlined" />
              {{ nowLang }}
            </div>
            <div v-if="principal.list.length" class="change-lang" @click="principal.modal = true">
              <dol-icon type="MailOutlined" />
              {{ $t('联系校长') }}
            </div>
          </div>
          <div class="header-menu">
            <template v-for="menu in menuListServer">
              <div v-if="menu.type === 'page'"
                   class="menu-item"
                   :class="{'active-menu': menuActive.path === menu.link || menuActive.path === menu._id || menuActive.parentId === menu._id}"
                   @click="goPage(menu)">
                {{ $dt(menu, 'name') }}
              </div>
              <a-dropdown v-if="menu.type === 'menu'" placement="bottomRight">
                <div class="menu-item" :class="{'active-menu': menuActive.parentId === menu._id}">
                  {{ $dt(menu, 'name') }}
                </div>
                <template #overlay>
                  <a-menu>
                    <a-menu-item v-for="page in menu.children" :key="page._id" @click="goPage(page)">
                      <div class="menu-item-row"
                           :class="{'active-sub-menu': menuActive.path === page.link || menuActive.path === page._id}">
                        {{ $dt(page, 'name') }}
                      </div>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body" ref="pageBody">
      <router-view v-slot="{ Component, route }">
        <keep-alive :include="['home','news']">
          <component :is="Component" :key="route.fullPath" @scrollToTop="scrollToTop" @homeScrollToSecond="homeScrollToSecond" />
        </keep-alive>
      </router-view>
      <div class="footer-box">
        <div class="footer-container">
          <img class="footer-logo" src="../../public/static/indexUse/logo2.png" />
          <div class="footer-left">
            <div class="school-name">{{ $t('上海松江区爱菊学校') }}</div>
            <div class="school-info">{{ $t('首页地址') }}</div>
          </div>
          <div class="footer-right" :style="$i18n.locale === 'en'?{gap:'24px'}:{}" v-if="!isMobile">
            <div v-for="item in footerList" :key="item._id" class="footer-column">
              <div class="column-title">{{ $dt(item, 'name') }}</div>
              <div v-for="page in item.pageArr" :key="page._id" class="column-item"
                   @click="$router.push(page.link || page._id)">
                {{ $dt(page, 'name') }}
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="footer-divider"></div>
          <div class="record-info-row">
            <a target="_blank" class="record-info"
               href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702891376">
              <img src="../../public/static/beian.png" style="margin-right: 4px" />
              沪公网安备 31011702891376号
            </a>
            <a target="_blank" class="record-info" href="http://beian.miit.gov.cn">沪ICP备12043526号-2</a>
          </div>
        </div>
      </div>
    </div>

    <a-modal v-model:visible="principal.modal" width="600px" :footer="null">
      <template #title>
        <div class="principal-modal-title">
          <dol-icon type="MailOutlined" />
          {{ $t('联系校长') }}
        </div>
      </template>
      <div class="principal-box">
        <div v-if="principal.main.length" class="principal-one-box">
          <div class="principal-title">
            <img src="../../public/static/indexUse/principle-1.svg" />
            <div>{{ $t('总校长') }}</div>
          </div>
          <div class="principal-row" v-for="item in principal.main" :key="item._id" @click="copyPath(item.content)">
            <div class="principal-name">{{ $dt(item, 'title') }}</div>
            <div class="principal-email">{{ item.content }}</div>
          </div>
        </div>
        <div v-if="principal.sub.length" class="principal-one-box">
          <div class="principal-title">
            <img src="../../public/static/indexUse/principle-2.svg" />
            <div>{{ $t('学部校长') }}</div>
          </div>
          <div class="principal-row" v-for="item in principal.sub" :key="item._id" @click="copyPath(item.content)">
            <div class="principal-name">{{ $dt(item, 'title') }}</div>
            <div class="principal-email">{{ item.content }}</div>
          </div>
        </div>
        <div class="principal-tip">{{ $t('点击可复制邮箱地址') }}</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
const mobileMediaQuery = window.matchMedia('(max-width: 991px)');

export default {
  name: "index",
  data() {
    return {
      headerListServer: [],
      footerList: [],
      menuPop: false,
      openKeys: [],
      selectedKeys: [],
      principal: {
        modal: false,
        list: [],
        main: [],
        sub: [],
      },
    };
  },
  watch: {
    $route(to, from) {
      this.makeMobileMenuPickRight();
    }
  },
  computed: {
    headerList() {
      const res = { outerList: [], innerList: [] };
      if (this.headerListServer.length <= 4) {
        res.outerList = this.headerListServer;
      } else {
        res.outerList = this.headerListServer.slice(0, 3);
        res.innerList = this.headerListServer.slice(3);
      }
      return res;
    },
    nowLang() {
      return this.$i18n.locale === 'zh' ? 'En' : '中文';
    },
    menuListServer() {
      const menuList = this.$store.state.app.menuList.filter(item => item.showFlag);
      menuList.forEach(menu => {
        if (!menu.children || !menu.children.length) return;
        menu.children = menu.children.filter(item => item.showFlag);
      });
      return menuList;
    },
    menuMap() {
      const map = {}, menuList = this.$store.state.app.menuList;
      menuList.forEach(menu => {
        map[menu._id] = menu;
        if (menu.children && menu.children.length) {
          menu.children.forEach(child => map[child._id] = child);
        }
      });
      return map;
    },
    menuMobile() {
      const menuList = this.$store.state.app.menuList.filter(item => item.showFlag);
      // console.log(menuListServer)
      return menuList.map(menu => {
        const nowItem = { key: menu._id, label: this.$dt(menu, 'name') };
        if (menu.type === 'menu' && menu.children) {
          const children = menu.children.filter(child => child.showFlag);
          if (children.length) {
            nowItem.children = menu.children.map(item => ({
              key: item._id,
              label: this.$dt(item, 'name')
            }));
          }
        }
        return nowItem;
      });
    },
    menuActive() {
      return this.$store.state.app.menuActive || { path: 'no' };
    },
    isMobile() {
      return this.$store.state.app.isMobile;
    }
  },
  methods: {
    headerLinkJump(item) {
      if (!item.link) return;
      window.open(item.link);
    },
    scrollToTop() {
      // 滚动到顶部
      this.$nextTick(() => {
        setTimeout(() => {
          // this.$refs.topBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
          this.$refs.pageBody.scrollTo({ top: 0, behavior: 'smooth' });
        }, 10);
      });
    },
    homeScrollToSecond(target) {
      this.$refs.pageBody.scrollTo({ top: target, behavior: 'smooth' });
    },
    menuClick({ key }) {
      const menu = this.menuMap[key];
      this.menuPop = false;
      this.goPage(menu);
    },
    changeLang() {
      this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
    },
    goPage(menu) {
      if (menu.type === 'page') {
        this.$router.push(menu.link || menu._id);
      }
    },
    queryHeader() {
      this.$ajax({ url: '/portal/portalHeaderFind', }).then(({ rows }) => {
        this.headerListServer = rows;
      });
    },
    queryFooter() {
      this.$ajax({ url: '/portal/portalFooterFind', }).then(({ rows }) => {
        this.footerList = rows;
      });
    },
    updateIsMobile(e) {
      this.$store.commit('app/setIsMobile', e.matches);
    },
    makeMobileMenuPickRight() {
      const pageMap = this.$store.state.app.pageMap;
      const nowPath = this.$route.path.replace('/', '');
      this.selectedKeys = [pageMap[nowPath]?._id];
    },
    queryPrincipal() {
      this.$ajax({ url: '/portal/queryCommonConfig', params: { code: 'principal-' } }).then(({ rows }) => {
        console.log(rows)
        const main = [], sub = [];
        for (const row of rows) {
          if (/main/.test(row.businessCode)) main.push(row);
          if (/sub/.test(row.businessCode)) sub.push(row);
        }
        this.principal.list = rows;
        this.principal.main = main;
        this.principal.sub = sub;
      });
    },
    copyPath(email) {
      // console.log(email)
      navigator.clipboard.writeText(email);
      this.$message.success(this.$t('地址已复制到剪贴板'));
    }
  },
  created() {
    this.queryHeader();
    this.queryFooter();
    this.queryPrincipal();
  },
  mounted() {
    this.updateIsMobile(mobileMediaQuery);
    mobileMediaQuery.addEventListener('change', this.updateIsMobile);
    this.makeMobileMenuPickRight();
  }
};
</script>

<style lang="scss">
@use '../assets/scss/constant' as constant;

.principal-modal-title {
  font-size: 18px;
  color: #003C82;
}

.principal-box {
  border-top: 1px solid #e2e8f0;
  margin: 0 -24px;
  padding: 0 24px;

  .principal-title {
    font-size: 16px;
    font-weight: bold;
    color: #003C82;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e2e8f0;
    padding: 8px 0;
    margin-top: 24px;

    img {
      height: 20px;
      width: 20px;
      margin-right: 4px;
    }
  }

  .principal-row {
    margin-top: 12px;
    background: #F5F5F5;
    border-radius: 14px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .principal-name {
      color: #333333;
    }

    .principal-email {
      color: #003C82;
    }

    &:hover {
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);

      .principal-email {
        color: #D93379;
      }
    }
  }

  .principal-tip {
    background: #F8FAFC;
    border-top: 1px solid #e2e8f0;
    text-align: center;
    padding: 16px;
    color: #003C82;
    margin: 32px -24px -20px;
    border-radius: 0 0 8px 8px;
  }
}

.menu-item-row {
  text-align: center;
  padding: 4px 12px;

  &.active-sub-menu {
    color: #D93379;
    font-weight: bold;
  }
}

.index-page {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;

  .page-header {
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.06);

    .header-1280 {
      width: 1280px;
      margin: auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-logo {
        height: 52px;
        width: auto;
        object-fit: contain;
      }

      .header-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;

        .header-right-top {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 24px;

          .dol-icon + span {
            margin-left: 4px;
          }
        }

        .out-link-box {
          display: flex;
          align-items: center;
        }
      }

      .header-menu {
        display: flex;
        align-items: center;
        gap: 36px;

        .menu-item {
          font-size: 16px;
          color: #003C82;
          cursor: pointer;
          transition: color 0.3s ease;
          white-space: nowrap;
          line-height: 40px;
          font-weight: bold;

          &:hover {
            color: #D93379;
          }

          &.active-menu {
            color: #D93379;
            font-weight: 500;
          }
        }

      }

      .change-lang {
        color: #003C82;
        cursor: pointer;
        white-space: nowrap;
        line-height: 40px;
        font-weight: bold;
      }
    }
  }

  .page-body {
    width: 100%;
    flex: 1;
    overflow-y: auto;
  }

  .footer-box {
    width: 100%;
    background: #002250;
    padding: 60px 0 30px;
    box-sizing: border-box;

    .footer-container {
      width: 1280px;
      margin: 0 auto;
      display: flex;

      .footer-logo {
        height: 96px;
        width: 96px;
        margin-right: 24px;
      }

      .footer-left {
        flex: 1;

        .school-name {
          font-weight: bold;
          color: #fff;
          line-height: 20px;
          margin-bottom: 16px;
        }

        .school-info {
          color: #BCBCBC;
          line-height: 18px;
          margin-bottom: 16px;
          white-space: pre-wrap;
        }
      }

      .footer-right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        gap: 68px;

        .footer-column {

          .column-title {
            font-weight: bold;
            color: #fff;
            line-height: 20px;
            margin-bottom: 16px;
            white-space: nowrap;
          }

          .column-item {
            color: #BCBCBC;
            line-height: 20px;
            margin-bottom: 16px;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }

    .footer-bottom {
      width: 1280px;
      margin: 40px auto 0;

      .footer-divider {
        width: 100%;
        height: 1px;
        background: rgba(255, 255, 255, 0.2);
        margin-bottom: 24px;
      }

      .record-info-row {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 32px;

        .record-info {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: 14px;
          opacity: 0.7;
          text-decoration: none;
        }
      }
    }
  }
}

// PC端
@media (min-width: #{constant.$mobileMaxWidth + 1}) {
  .index-page {
    //font-weight: bold;
    .page-header {
      height: 80px;
    }
  }
}

// 移动端
@media (max-width: constant.$mobileMaxWidth) {
  .ant-menu-item-selected {
    color: #D93379 !important;
    background-color: rgba(#D93379, 0.1) !important;
  }
  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: #D93379 !important;
  }
  .index-page {
    .page-header {
      height: 60px;

      .header-1280 {
        width: 100%;
        padding-left: 24px;

        .header-logo {
          height: 32px;
        }

        .change-lang {
          font-size: 14px;
          color: #003C82;
          cursor: pointer;
          white-space: nowrap;
          line-height: 40px;
          font-weight: bold;
          margin-right: 12px;
        }

        .menu-mobile {
          background: #D93379;
          color: white;
          height: 60px;
          line-height: 60px;
          width: 48px;
          text-align: center;
          font-size: 22px;
        }
      }
    }

    .footer-box {
      //width: 100vw;
      padding: 36px 0 24px;

      .footer-container {
        //width: 100vw;
        width: 100%;
        padding: 0 24px;

        .footer-left {
          .school-name {
            margin-bottom: 10px;
          }

          .school-info {
            line-height: 14px;
            margin-bottom: 10px;
          }
        }
      }

      .footer-bottom {
        //width: 100vw;
        width: 100%;
        margin: 4px auto 0;

        .footer-divider {
          margin-bottom: 12px;
        }

        .record-info-row {
          flex-direction: column;
          gap: 8px;
        }
      }
    }
  }
}
</style>
